import { gql } from "@apollo/client";

export const CREATE_CONFIGURATION = gql`
  mutation createConfiguration($input: configurations_insert_input!) {
    insert_configurations_one(object: $input) {
      configuration_name
      configuration_value
      configuration_html_value
    }
  }
`;

export const UPDATE_CONFIGURATION = gql`
  mutation updateConfiguration(
    $cName: configuration_type_enum!
    $input: configurations_set_input!
  ) {
    update_configurations_by_pk(
      pk_columns: { configuration_name: $cName }
      _set: $input
    ) {
      configuration_name
      configuration_html_value
      configuration_value
    }
  }
`;

export const GET_CONFIGURATION_BY_NAME = gql`
  query getConfigurationByName($cName: configuration_type_enum!) {
    configurations(where: { configuration_name: { _eq: $cName } }) {
      configuration_name
      configuration_html_value
      configuration_value
    }
  }
`;

export const GET_ALL_CONFIGURATION = gql`
  query getAllConfigurations {
    configurations {
      configuration_name
      configuration_html_value
      configuration_value
    }
  }
`;

export const INSERT_FAQS = gql`
mutation InsertFAQs($FAQs: [frequently_asked_questions_insert_input!]!) {
  insert_frequently_asked_questions(objects: $FAQs, on_conflict: {constraint: frequently_asked_questions_faq_question_key, update_columns: [faq_answer, faq_deleted_at]}) {
    affected_rows
  }
}
`
export const GET_ALL_FAQS = gql`
query getAllFAQs{
  frequently_asked_questions(where: {faq_deleted_at: {_is_null: true}}, order_by: {faq_created_at: desc}){
    faq_id
    faq_question
    faq_answer
  }
  frequently_asked_questions_aggregate(where: {faq_deleted_at: {_is_null: true}}){
    aggregate{
      count
    }
  }
}
`

export const DELETE_QUESTION = gql `
mutation deleteFAQById($FAQId: uuid!){
  update_frequently_asked_questions_by_pk(pk_columns:{faq_id: $FAQId}, _set:{faq_deleted_at: "now()"}){
    faq_id
    faq_question
    faq_answer
    faq_deleted_at
  }
}
`

export const GET_A_QUESTION = gql `
query getFAQById($FAQId: uuid!){
  frequently_asked_questions(where:{faq_id: {_eq: $FAQId}, faq_deleted_at: {_is_null: true}}){
    faq_id
    faq_question
    faq_answer
  }
}
`
export const UPDATE_QUESTION = gql `
mutation UpdateFAQById($FAQId: uuid!, $input: frequently_asked_questions_set_input){
  update_frequently_asked_questions_by_pk(pk_columns:{faq_id: $FAQId}, _set: $input){
    faq_id
    faq_question
    faq_answer
  }
}
`

export const GET_CURRENT_APP_VERSION = gql`
query GetCurrentAppVersion {
  app_version_info {
      app_os_name
      app_should_force_update
      app_version
  }
}
`
export const UPDATE_VERSION = gql`
mutation UpdateCurrentAppVersion ($appOsName: String!, $appVersion: String!, $shouldForceUpdate: Boolean = false) {
  update_app_version_info(where: {app_os_name:{_eq:$appOsName}}, _set: {app_version:$appVersion,app_should_force_update:$shouldForceUpdate}) {
    affected_rows
    returning {
      app_os_name
      app_version
      app_should_force_update
    }
  }
}
`

export const UPDATE_VERSION_NOTIFICATION =gql`
mutation updateAppVersionNotification($appOsName: String!, $appVersion: String!, $shouldForceUpdate: Boolean = false) {
  updateAppVersion(appOsName: $appOsName, appVersion: $appVersion, shouldForceUpdate: $shouldForceUpdate) {
    message
  }
}
`

export const ADD_TOP_UP=gql`
mutation addFund($amount: Float!) {
  addFund(amount: $amount){
    message
  }
}`

export const SEARCH_LEAGUE=gql`
query LeaguesDropdownFilter {
  leagues(where: {l_deleted_at:{_is_null:true}}, order_by: {l_name:asc}) {
    l_id
    l_name
  }
}`;

export const SEARCH_LEAGUE_CATEGORIES=gql`
query searchLeagueCategories ($search: String = "%", $leagueId: uuid!) {
  league_categories(where: {lc_name:{_ilike:$search},lc_deleted_at:{_is_null:true},league:{l_id:{_eq:$leagueId}},lc_ticketmaster_name: { _is_null: false }}, order_by: {lc_name:asc}) {
    lc_id
    lc_name
    lc_alternate_name
    lc_brand_name
    lc_market_name
  }
}`;

export const INSERT_ALTERNATE_NAME=gql`
mutation updatedAltandTeamNameByCategoryId($leagueCategoryId: String!, $alternateName: String, $brandName: String, $marketName: String) {
  insertAlternateName(
    leagueCategoryId: $leagueCategoryId
    alternateName: $alternateName
    brandName: $brandName
    marketName: $marketName
  ) {
    message
  }
}
`;

export const GET_AVAILABLE_ALTERNATE_NAMES=gql`
query getLCAlternateName($l_id: uuid!, $lc_id: uuid!) {
  league_categories(where: {_and: [{league: {l_id: {_eq: $l_id}}}, {lc_id: {_eq: $lc_id}}]}) {
    lc_alternate_name
    lc_brand_name
    lc_market_name
    lc_name
  }
}
`;

export const GET_REMINDER=gql`
 query ReminderSettings {
            reminder_settings {
              reminder_id
              reminder_days
              no_of_reminders
              reminder_is_enable
            }
          }
  `;

export const UPDATE_REMINDER=gql`
mutation UpdateReminderDays($reminderDays: [Int!]!) {
  update_reminder_settings(where: {type: { _eq: "reminder_mail" }}, _set: {reminder_days: $reminderDays}) {
    affected_rows
    returning {
      no_of_reminders
      reminder_days
    }
  }
}
`;

export const ENABLE_REMINDER=gql`
mutation ToggleReminder($isEnabled: Boolean!) {
  update_reminder_settings(where: {type: {_eq: "reminder_mail"}}, _set: {reminder_is_enable: $isEnabled}) {
    affected_rows
    returning {
      no_of_reminders
      reminder_days
      reminder_is_enable
    }
  }
}`;